import React from 'react';

import Select, { SingleValue, SingleValueProps } from 'react-select';

import { Flex } from 'components';

import { InlineDropdownOption } from '../../constants/InlineDropdownOption';

import styles from './InlineDropdown.scss';

type InlineDropdownProps = {
  options: InlineDropdownOption[];
  value?: {
    label: string;
    value: string;
  };
  onChange?: (option: InlineDropdownOption | null) => void;
  ariaLabel: string;
};

const InlineDropdown = ({
  options,
  value,
  onChange,
  ariaLabel,
}: InlineDropdownProps) => {
  const CustomInlineDropdown = (props: SingleValueProps<InlineDropdownOption>) => {
    return (
      <Flex align="center">
        <span>{props.data.label}</span>
      </Flex>
    );
  };

  return (
    <Select<InlineDropdownOption, false>
      aria-label={ariaLabel}
      options={options}
      value={value as InlineDropdownOption | undefined}
      onChange={(newValue: SingleValue<InlineDropdownOption>) => {
        onChange?.(newValue ?? null);
      }}
      className={styles.CustomInlineDropdown}
      styles={{
        control: (baseStyles: any) => ({
          ...baseStyles,
          border: 'none',
          ':hover': {
            backgroundColor: '#EBEBFF',
          },
        }),
        indicatorSeparator: (styles: any) => ({
          ...styles,
          display: 'none',
        }),
        dropdownIndicator: (styles: any) => ({
          ...styles,
          display: 'none',
        }),
      }}
      components={{
        SingleValue: CustomInlineDropdown,
      }}
    />
  );
};

export default InlineDropdown;
